import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDivisionAvailableColumns, getRealEstatesShort } from './api';

export const path = '/division/list';

const PageDivision: React.FC = (props) => {
  const Division = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDivisionAvailableColumns,
      realEstates: getRealEstatesShort,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Division {...props} />;
};

export default PageDivision;
